import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Title from "../../ui/Title/Title";
import styles from "./AllInfoBotContainer.module.scss";
import { MessageBotIcon } from "../../assets/icons/MessageBotIcon";
import Switcher from "../../ui/Switcher/Switcher";
import Chip from "../../ui/Chip/Chip";
import { useNavigate } from "react-router-dom";
import { updateTgBot } from "../../utils/api/actions/integrations/tgBot";

export default function AllInfoBotContainer() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { activeBot } = useSelector((state) => state.integration.activeBot);
  const { dataAssistants } = useSelector((state) => state.assistant);

  const [isSwitchOn, setIsSwitchOn] = useState(activeBot.active || false);

  const botActive = isSwitchOn;

  const getAssistantName = (id) => {
    const assistant = dataAssistants.find((assistant) => assistant.id === id);
    return assistant ? assistant.name : null; // Возвращаем имя, если ассистент найден, или null
  };

  const hiddenToken = (str) => {
    let arr = str.split("");

    for (let i = 0; i < arr.length; i++) {
      if (i > 4 && i < 40) {
        arr.splice(i, 1, "*");
      }
    }

    return arr.join("");
  };

  const handleToggle = () => {
    const newStatus = !isSwitchOn;
    setIsSwitchOn(newStatus);

    if (activeBot?.id) {
      const updatedData = {
        ...activeBot,
        active: newStatus,
      };
      dispatch(updateTgBot(updatedData, navigate));
    }
  };

  const DataItem = ({ title, data }) => {
    return (
      <div className={styles.dataItemContainer}>
        <label className={styles.title}>{title}</label>
        <label className={styles.data}>{data}</label>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Title title={activeBot.name} className={styles.title} />
        <MessageBotIcon sizeContainer={"30px"} size={20} fill={"white"} />
        <Chip
          classNameChip={styles.chipContainer}
          active={botActive}
          classNameChipActive={styles.chipContainerActive}
          classNameChipDisabled={styles.chipContainerDisabled}
          title={botActive ? "Активен" : "Не активен"}
        />
      </div>
      <div className={styles.rowData}>
        <DataItem title="Имя пользователя" data={activeBot.userName} />
        <DataItem title="Название" data={activeBot.name} />
        <DataItem
          title={"Статус"}
          data={
            <Switcher
              switchStyle={styles.switchContainer}
              bool={isSwitchOn}
              onToggle={handleToggle}
            />
          }
        />
      </div>
      <DataItem title="Токен" data={hiddenToken(activeBot.token)} />
      <DataItem title="Описание" data={activeBot.description} />
      <DataItem title="Короткое описание" data={activeBot.about} />
      <DataItem
        title="Приветственное сообщение"
        data={activeBot.helloMessage}
      />
      <DataItem
        title="Ассистент"
        data={getAssistantName(activeBot.assistantId)}
      />
    </div>
  );
}
